<template>
  <a-flex vertical gap="large">
    <a-card size="small">
      <a-input
        v-model:value="supportAdminStore.searchFilter"
        @change="filterRequests"
        placeholder="Поиск по аккаунтам, номерам заявок, темам обращений, авторам."
        :allowClear="true"
      />
    </a-card>

    <a-flex gap="24" justify="space-between">
      <!--      <SupportAdminServices />-->

      <div style="flex-grow: 1">
        <router-view />
      </div>

      <SupportAdminRequests style="flex-grow: 0" />
    </a-flex>
  </a-flex>
</template>

<script setup lang="ts">
// import SupportAdminServices from "@/components/settings/support/admin/services/SupportAdminServices.vue";
import SupportAdminRequests from "@/components/settings/support/admin/requests/SupportAdminRequests.vue";
import { useSupportAdminStore } from "@/stores/support/support-admin.store";
import { useChatStore } from "@/stores/chat/chat.store";
import { onMounted, onUnmounted } from "vue";
import { debounce } from "@/tools/debounce";

const supportAdminStore = useSupportAdminStore();
const chatStore = useChatStore();

const filterRequests = debounce(supportAdminStore.fetchAllAdminChats, 600);

onMounted(async () => {
  await supportAdminStore.initialize();
});

onUnmounted(async () => {
  await chatStore.clearAllData();
});
</script>

<style scoped lang="scss"></style>
